<template>
    <div class="w-20 h-20 text-gray-800 select-none">
        <span v-if="iconToDisplay == 'doc'">
            <svg class="w-full" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
            </svg>
        </span>
        <span v-else-if="iconToDisplay == 'audio'">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"></path>
            </svg>
        </span>
        <span v-else-if="iconToDisplay == 'video'">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
            </svg>
        </span>
    </div>
</template>

<script>
export default {
    name: "media-message-preview",
    props: ["file"],
    data () {
        return {
            fileType: this.file.type ? this.file.type : "other"
        };
    },
    computed: {
        iconToDisplay () {
            if (this.fileType.includes("jpg") ||
                this.fileType.includes("png") ||
                this.fileType.includes("jpeg") ||
                this.fileType.includes("image") ||
                this.fileType.includes("gif")
            ) {
                return "none";
            }
            if (this.fileType.includes("audio") ||
                this.fileType.includes("mp3") ||
                this.fileType.includes("wav")) {
                return "audio";
            }
            if (this.fileType.includes("vid") ||
                this.fileType.includes("mov") ||
                this.fileType.includes("avi") ||
                this.fileType.includes("mp4") ||
                this.fileType.includes("vlc") ||
                this.fileType.includes("flv") ||
                this.fileType.includes("mpg") ||
                this.fileType.includes("mpeg")) {
                return "video";
            }
            return "doc";
        }
    }
};
</script>

<style scoped>

</style>
